// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"d1-z","dimensionLabel":"e1-z","styleChooserControlWrapper":"f1-z","styleChooserControl":"g1-z","disabled":"h1-z","giftCard":"i1-z","styleChooserText":"j1-z"};